import type { ReactElement } from "react";
import { Alert, Snackbar, SnackbarOrigin } from "@mui/material";

const DEFAULT_AUTO_HIDE_DURATION = 5000;
interface NotificationToastProps {
  message?: string;
  showToast: boolean;
  isError: boolean;
  autoHideDuration?: number;
  anchorOrigin?: SnackbarOrigin;
  includeTopOffset?: boolean;
  onClose: () => void;
}

const NotificationToast = ({
  message,
  showToast,
  isError,
  autoHideDuration,
  anchorOrigin,
  includeTopOffset = true,
  onClose,
}: NotificationToastProps): ReactElement => {
  return (
    <Snackbar
      open={showToast}
      autoHideDuration={autoHideDuration ?? DEFAULT_AUTO_HIDE_DURATION}
      onClose={onClose}
      anchorOrigin={
        anchorOrigin ? anchorOrigin : { vertical: "top", horizontal: "center" }
      }
      style={includeTopOffset ? { top: 1 } : undefined}
    >
      <Alert
        severity={isError ? "error" : "info"}
        onClose={onClose}
        sx={{ width: "fit-content" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationToast;
